export type ImageCompressionSettings = {
  enabled: boolean;
  maxWidth: number;
  maxHeight: number;
  quality: number;
};

export const defaultImageCompressionSettings: ImageCompressionSettings = {
  enabled: true,
  maxWidth: 1600,
  maxHeight: 1600,
  quality: 0.72
};

function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const url = URL.createObjectURL(file);

    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve(image);
    };

    image.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Nao foi possivel ler a imagem."));
    };

    image.src = url;
  });
}

export async function compressImageFile(file: File, settings: ImageCompressionSettings): Promise<File> {
  if (!settings.enabled || !file.type.startsWith("image/")) {
    return file;
  }

  const image = await loadImage(file);
  const scale = Math.min(1, settings.maxWidth / image.naturalWidth, settings.maxHeight / image.naturalHeight);
  const width = Math.max(1, Math.round(image.naturalWidth * scale));
  const height = Math.max(1, Math.round(image.naturalHeight * scale));

  const canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext("2d");
  if (!context) {
    return file;
  }

  context.drawImage(image, 0, 0, width, height);

  const blob = await new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, "image/jpeg", Math.min(0.95, Math.max(0.35, settings.quality)));
  });

  if (!blob || blob.size >= file.size) {
    return file;
  }

  const baseName = file.name.replace(/\.[^.]+$/, "");
  return new File([blob], `${baseName || "foto-imobi"}.jpg`, {
    type: "image/jpeg",
    lastModified: Date.now()
  });
}

export async function compressImageFiles(files: File[], settings: ImageCompressionSettings): Promise<File[]> {
  return Promise.all(files.map((file) => compressImageFile(file, settings)));
}
